import { getSearchPath } from "@m10s/mobility-mapping-utils";
import { useScreenSize } from "@mobility-item-page/client";
import type { LatestAdsBySearchKey } from "@mobility-item-page/dealer";
import { Button } from "@warp-ds/elements/react/button";
import { memo, type RefObject } from "react";
import { trackSeeAdInCategory, trackSeeAllListings } from "src/utils/pulseHelper.ts";
import { useAppConfig } from "../../context/AppConfigProviderContext.tsx";
import { useOrganisation } from "../../context/DealerDataProviderContext.tsx";
import { TabId } from "../../utils/tabs.ts";
import ItemCard from "../Components/Cards/ItemCard.tsx";
import { ScrollContainer } from "../Components/ScrollContainer.tsx";
import "./sections.css";

// @ts-expect-error - The type is exported
import type { SearchKey } from "@m10s/search-frontend-clients/quest";

export const DealerAds = memo(
  ({
    ref,
    ads,
    className,
  }: {
    ref?: RefObject<HTMLDivElement | null>;
    ads: LatestAdsBySearchKey[];
    className?: string;
  }) => {
    const { name } = useOrganisation();
    const { mountOrigin } = useAppConfig();
    const { isMobile } = useScreenSize();

    const resolvedClassName = className ? `${className} section w-full` : "section w-full";

    return (
      <section id={TabId.DealerAds} ref={ref} className={resolvedClassName}>
        {ads.map((adsCategory, index) => {
          const searchLink = `${mountOrigin}${getSearchPath(adsCategory.searchKey as SearchKey, new URLSearchParams(adsCategory.searchPageUrlQueryParams.map((param) => [param.key, param.value])))}`;
          return (
            <div className={ads.length - 1 === index ? "" : "mb-56"} key={adsCategory.searchKey}>
              <h3 className="mb-16">{adsCategory.heading}</h3>
              <ScrollContainer
                className="flex gap-x-16 overflow-x-scroll overflow-y-hidden"
                searchKey={adsCategory.searchKey}
                scrollButtonOffset={60}
              >
                {adsCategory.ads.map((item) => {
                  return (
                    <ItemCard
                      key={item.adId}
                      adId={item.adId}
                      image={item.imageUrl}
                      price={item.price}
                      title={item.title}
                      subTitle={item.subTitle}
                      url={`${mountOrigin}/mobility/item/${item.adId}`}
                      onClick={() =>
                        trackSeeAdInCategory(
                          item.adId,
                          item.title,
                          adsCategory.searchKey,
                          `${mountOrigin}/mobility/item/${item.adId}`,
                        )
                      }
                    />
                  );
                })}
              </ScrollContainer>
              {(adsCategory.ads.length >= 15 || (!isMobile && adsCategory.ads.length > 3)) && (
                <div className="flex justify-center mt-40">
                  <Button
                    className="max-w-[260]"
                    fullWidth
                    href={searchLink}
                    onClick={() => trackSeeAllListings(adsCategory.searchKey, searchLink, name)}
                  >
                    {adsCategory.linkTitle}
                  </Button>
                </div>
              )}
            </div>
          );
        })}
      </section>
    );
  },
);
